import { render, staticRenderFns } from "./fileOpen.vue?vue&type=template&id=389020ce&"
import script from "./fileOpen.vue?vue&type=script&lang=ts&"
export * from "./fileOpen.vue?vue&type=script&lang=ts&"
import style0 from "./fileOpen.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports